import { useClientSettings } from "@hooks/useClientSettings";

type LogoProps = {
  icon?: boolean;
  variant?: "default" | "header";
};

export const Logo = ({ icon, variant = "default" }: LogoProps) => {
  const client = useClientSettings();
  const logoUrl =
    variant === "header"
      ? (client.assets.logo_header ?? client.assets.logo)
      : client.assets.logo;
  const url = icon ? client.assets.favicon : logoUrl;

  return (
    <img style={{ maxWidth: "100%", maxHeight: "100%" }} src={url} alt="Logo" />
  );
};
